import { BrowserModule } from '@angular/platform-browser';
import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  APP_INITIALIZER,

} from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MaterialModule } from './material-module';
import { AsyncPipe, DatePipe } from '@angular/common';
import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient,
} from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SidebarComponent } from './shared/sidebar/sidebar.component';
import { FooterComponent } from './shared/footer/footer.component';
import { ContentAnimateDirective } from './shared/directives/content-animate.directive';
// import { MissionComponent } from './screens/mission/mission.component';
import { ToastrModule } from 'ngx-toastr';
// import { TableModule } from 'primeng/table';
import { LoginComponent } from './screens/authentications/login/login.component';
// import { OrganizationChartModule } from 'primeng/organizationchart';
// import { TreeTableModule } from 'primeng/treetable';
// import { ToastModule } from 'primeng/toast';
// import { PanelModule } from 'primeng/panel';
// import { ContextMenuModule } from 'primeng/contextmenu';
// Prime NG Imports
// import { ButtonModule } from 'primeng/button';
// import { SidebarModule } from 'primeng/sidebar';
// import { InputTextModule } from 'primeng/inputtext';
// import { DropdownModule } from 'primeng/dropdown';
// import { MultiSelectModule } from 'primeng/multiselect';
// import { TieredMenuModule } from 'primeng/tieredmenu';
// import { MessageService } from 'primeng/api';
import { AuthenticationService } from './services/authentication.service';
// import { DialogModule } from 'primeng/dialog';
// import { CalendarModule } from 'primeng/calendar';
// import { InputSwitchModule } from 'primeng/inputswitch';
import { CommonModule } from '@angular/common';
// import { InputNumberModule } from 'primeng/inputnumber';
// import { ConfirmationService } from 'primeng/api';
// import { CardModule } from 'primeng/card';
import { AgGridModule } from 'ag-grid-angular';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { PrimeCellEditorComponent } from './editors/prime-cell-editor.component';
import { CustomDateComponent } from './date-components/custom-date-component.component';
import { BtnCellRenderer } from './btn-cell-renderer.component';
// import { TreeModule } from 'primeng/tree';
// import { ColorPickerModule } from 'primeng/colorpicker';
// import { RadioButtonModule } from 'primeng/radiobutton';
import { NgxSpinnerModule } from 'ngx-spinner';
// import { InputMaskModule } from 'primeng/inputmask';
import { WelcombannerService } from './services/welcombanner.service';
// import { TooltipModule } from 'primeng/tooltip';
import { PrivateLayoutComponent } from './shared/private-layout/private-layout.component';
import { PublicLayoutComponent } from './shared/public-layout/public-layout.component';
import { SignUpComponent } from './screens/authentications/sign-up/sign-up.component';
import { ForgotPasswordComponent } from './screens/authentications/forgot-password/forgot-password.component';
import { WelcomeBannerComponent } from './shared/welcome-banner/welcome-banner.component';
// Start Material Modules
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatTreeModule } from '@angular/material/tree';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
// import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { MatExpansionModule } from '@angular/material/expansion';
// import {
//   // NgxMatDatetimePickerModule,
//   NgxMatNativeDateModule,
// } from '@angular-material-components/datetime-picker';
import { MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatGridListModule } from '@angular/material/grid-list';

// End Material Modules
// import { UsermanagementComponent } from './screens/usermanagement/usermanagement.component';
import { AnalyticsComponent } from './screens/analytics/analytics.component';

// import { AccessModule } from './Access/access.module';


// import { NgApexchartsModule } from 'ng-apexcharts';
import { MatSelectFilterModule } from 'mat-select-filter';

import { BtnDeleteCellRenderer } from './btn-deletecell-renderer';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatRadioModule } from '@angular/material/radio';
// import { ChartsModule } from 'ng2-charts';
// import { ChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts';
// // import * as more from 'highcharts/highcharts-more.src';
// import * as exporting from 'highcharts/modules/exporting.src';
// import * as drilldown from 'highcharts/modules/drilldown.src';
import { CustomTooltip } from './custom-tooltip.component';
import { ScrollingModule } from '@angular/cdk/scrolling';

// import { NZ_I18N } from 'ng-zorro-antd/i18n';
// import { en_US } from 'ng-zorro-antd/i18n';
import { registerLocaleData } from '@angular/common';
import en from '@angular/common/locales/en';
// import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
// import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { DatetestComponent } from './datetest/datetest.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslaterService } from './services/translater.service';
import { PDFExportRenderer } from './pdf-export-renderer.component';
import { PalletActionRenderer } from './pallet-action-renderer';
// import stock from 'highcharts/modules/stock';

// import { NgxDropzoneModule } from 'ngx-dropzone';
import { VersionCheckService } from './services/VersionCheckService';
import { NgxMatSelectConfigs, NGX_MAT_SELECT_CONFIGS } from './ngx-mat-select/ngx-mat-select-configs';
import { NgxMatSelectModule } from './ngx-mat-select/ngx-mat-select.module';
import { CheckBoxCellRenderer } from './checkbox-cell-renderer.component';

import { DataService } from './services/data.service';
import { AddEditDeleteActionRendererComponent } from './add-edit-delete-action-renderer/add-edit-delete-action-renderer.component';
import { NumberInputRendererComponent } from './number-input-renderer/number-input-renderer.component';
import { BtnCloseCellRenderer } from './btn-close-renderer';
import { PmEditRendererComponent } from './components/pm-edit-renderer/pm-edit-renderer.component';
import { PmDeleteRendererComponent } from './components/pm-delete-renderer/pm-delete-renderer.component';
import { ToggleBtnCellRenderer } from './toggle-btn-cell-renderer';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
// import { HighchartsService } from './services/highcharts.service';
import { KPIMilestoneService } from './services/KPI-milestone.service';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { BtnCellRendererEditBtn } from './btn-cellRenderer-EditBtn';
import { MessagingService } from './services/messaging.service';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AngularFireModule } from '@angular/fire/compat';
import { JwtDecoderService } from 'src/backend/helpers/jwt-decoder.service';
import { JwtModule, JwtModuleOptions } from '@auth0/angular-jwt';
import { AuthService } from 'src/backend/services/auth.service';
import { Constants } from 'src/@smartmanufacturing/common/constants';
import { UserDeviceService } from 'src/backend/services/user-device.service';
import { MessagingService as _MessagingService } from 'src/backend/services/messaging.service';
import { TokenInterceptor } from 'src/backend/helpers/token.interceptor';
import { FeatureService } from 'src/backend/services/user-access-services/feature.service';
import { GroupService } from 'src/backend/services/user-access-services/groups.service';
import { PlantService } from 'src/backend/services/user-access-services/plant.service';
import { UserService } from 'src/backend/services/user-access-services/user.service';
import { EmployeeService } from 'src/backend/services/user-access-services/employee.service';
import { RoleService } from 'src/backend/services/user-access-services/role.service';
import { MultiplePlantRequestService } from 'src/backend/services/user-access-services/multiple-plant.request.service';
import { PermissionService } from 'src/backend/services/permission.service';
import { NotificationsComponent } from './shared/notifications/notifications.component';
import { AccountService } from './services/account.service';
import { ConfirmEmailComponent } from './static/confirm-email/confirm-email.component';
import { AvatarModule } from "ngx-avatar";
import { DismissAlertComponent } from './user-management/shared/components/dismiss-alert/dismiss-alert.component';
import { MatCheckboxRendererComponent } from './mat-checkbox-renderer';
import { MatSelectRendererComponent } from './mat-selectlist-renderer';
import { MatIconModule } from '@angular/material/icon';

import { ConfirmationComponent } from './confirmation/confirmation.component';
// import { MatProgressButtonsModule } from 'mat-progress-buttons';
import { NavbarComponent } from './shared/navbar/navbar.component';
import { HomeModule } from './screens/home.module';
import { ButtonEditCopyRendererComponent } from './components/button-edit-copy-render.components';
import { FormBuilderComponent } from './form-builder/form-builder.component';
import { FormViewerComponent } from './screens/form-viewer/form-viewer.component';
import { UIBuilderSharedModule } from './shared';
import { DndModule } from 'ngx-drag-drop';
import { SharedModule } from './user-management/shared/shared.module';
import { OpenaiChatComponent } from './shared/openai-chat/openai-chat.component';
import { ButtonEditViewDeleteRendererComponent } from './components/button-edit-delete-view-render.components';
import { A11yModule } from "@angular/cdk/a11y";
import { ButtonManageApprovalRendererComponent } from './components/button-manage-aaproval-render.components';
import { ConfigService } from './services/config.service';
import { initializeApp } from 'src/app/app-initializer';


const SANED_SERVICES = [
  JwtDecoderService,
  AuthService,
  _MessagingService,
  UserDeviceService,
  FeatureService,
  GroupService,
  PlantService,
  UserService,
  EmployeeService,
  RoleService,
  MultiplePlantRequestService,
  PermissionService,
];

const avatarColors = ["#FFB6C1", "#2c3e50", "#95a5a6", "#f39c12", "#1abc9c"];

export function getToken() {
  const token = localStorage.getItem(Constants.AUTH_TOKEN);
  if (token) {
    return token;
  }
  return null;
}


const JWT_Module_Options: JwtModuleOptions = {
  config: {
    tokenGetter: getToken,
    // Use `allowedDomainPatterns` instead of `allowedDomains`
    //allowedDomainPatterns: environment.white_listed_Domains.map(domain => new RegExp(domain)),
    headerName: 'Authorization',
    authScheme: 'Bearer ',
  },
};


// export function highchartsModules() {
//   // apply Highcharts Modules to this array
//   return [stock, more];
// }

registerLocaleData(en);
export const ngxMatSelectConfigs: NgxMatSelectConfigs = {
  maxWidthForMobileView: 600,
  inFirstLoadCallSearcher: true,
  inFirstLoadSearcherValue: '',
  emptyLabel: 'no entry found',
  noMoreResultLabel: 'no more found',
  useInfiniteScroll: false,
  searchBoxPlaceholder: 'please search',
  maximumResultForShow: 40000,
  useMobileView: false,
  valueMember: 'key',
  displayMember: 'value',
  mobileViewType: 'FullScreen',
};
@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    SidebarComponent,
    FooterComponent,
    ContentAnimateDirective,
    // MissionComponent,
    LoginComponent,
    PrimeCellEditorComponent,
    // DefectManagementMasterComponent,
    CustomDateComponent,
    ToggleBtnCellRenderer,
    BtnCellRenderer,
    BtnDeleteCellRenderer,
    BtnCellRendererEditBtn,
    PDFExportRenderer,
    PrivateLayoutComponent,
    PublicLayoutComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    WelcomeBannerComponent,
    // UsermanagementComponent,
    AnalyticsComponent,

    AnalyticsComponent,

    CustomTooltip,
    DatetestComponent,
    AddEditDeleteActionRendererComponent,
    NumberInputRendererComponent,

    CheckBoxCellRenderer,
    BtnCloseCellRenderer,
    CheckBoxCellRenderer,
    PmEditRendererComponent,
    PmDeleteRendererComponent,
    NotificationsComponent,
    ConfirmEmailComponent,
    DismissAlertComponent,

    ConfirmationComponent,
    MatCheckboxRendererComponent,
    MatSelectRendererComponent,
    ButtonEditCopyRendererComponent,  
    FormBuilderComponent,
    FormViewerComponent,
    OpenaiChatComponent,
    ButtonEditViewDeleteRendererComponent,
    ButtonManageApprovalRendererComponent
  ],
  imports: [
    BrowserModule,
    // MatProgressButtonsModule.forRoot(),
    AngularFireMessagingModule,
    AngularFireModule.initializeApp(Constants.FIREBASE_CONFIG),
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: httpTranslateLoader,
            deps: [HttpClient],
        },
    }),
    JwtModule.forRoot(JWT_Module_Options),
    AppRoutingModule,
    BrowserAnimationsModule,
    ReactiveFormsModule,
    FormsModule,
    NgbModule,
    HttpClientModule,
    DndModule,
    MatSelectFilterModule,
    MatRadioModule,
    NgxSpinnerModule,
    // InputTextModule,
    // DropdownModule,
    // MultiSelectModule,
    // TieredMenuModule,
    // TableModule,
    // DropdownModule,
    // MultiSelectModule,
    // TieredMenuModule,
    // DialogModule,
    // CalendarModule,
    // InputSwitchModule,
    ScrollingModule,
    DragDropModule,
    CommonModule,
    MatDialogModule,
    MatBottomSheetModule,
    MatGridListModule,
    MatSelectModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatIconModule,
    ToastrModule.forRoot({
        timeOut: 2000,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
    }),
    MatMenuModule,
    MatButtonModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatFormFieldModule,
    MatInputModule,
    MatTreeModule,
    MatCardModule,
    MatSelectModule,
    MatNativeDateModule,
    MatDatepickerModule,
    MatDialogModule,
    MaterialModule,
    MatExpansionModule,
    // AccessModule,
    MatTooltipModule,
    MatInputModule,
    MatSlideToggleModule,
    NgxMatSelectModule.forRoot({
        maxWidthForMobileView: 600,
        inFirstLoadCallSearcher: true,
        inFirstLoadSearcherValue: '',
        emptyLabel: 'no entry found',
        noMoreResultLabel: 'no more found',
        useInfiniteScroll: false,
        searchBoxPlaceholder: 'Search',
        maximumResultForShow: 4000,
        useMobileView: false,
        valueMember: 'key',
        displayMember: 'value',
        mobileViewType: 'FullScreen',
    }),
    AvatarModule.forRoot({
        colors: avatarColors
    }),
    UIBuilderSharedModule,
    SharedModule,
    A11yModule
],
  providers: [
    DatePipe,
    // MessageService,
    TranslaterService,
    AuthenticationService,
    // ConfirmationService,
    VersionCheckService,
    MessagingService,
    AsyncPipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    // { provide: NZ_I18N, useValue: en_US },

    { provide: NGX_MAT_SELECT_CONFIGS, useValue: ngxMatSelectConfigs },
    WelcombannerService,
    // HighchartsService,
     ConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [ConfigService],
      multi: true
    },
    DataService,
    KPIMilestoneService,
    AccountService,
    ...SANED_SERVICES,

  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule { }

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
